import useTracker from '@hooks/useTracker';
import {
  CLICK_RDN_PROCESSED_BUTTON,
  CLICK_RDN_PROCESSED_BUTTON_CLOSE,
  VIEW_RDN_BALANCE_PROCESSED_PAGE,
} from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickRdnProcessed = () => {
    trackEvent(CLICK_RDN_PROCESSED_BUTTON);
  };

  const eventClickRdnProcessedClose = () => {
    trackEvent(CLICK_RDN_PROCESSED_BUTTON_CLOSE);
  };

  const eventViewRdnProcessedPage = () => {
    trackEvent(VIEW_RDN_BALANCE_PROCESSED_PAGE);
  };

  return {
    eventClickRdnProcessed,
    eventClickRdnProcessedClose,
    eventViewRdnProcessedPage,
  };
};

export default useEventTracker;
